<template>
  <div class="toast-container">
    <transition-group name="toast">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="app-toast"
        :class="`app-toast--${t.type}`"
        @click="remove(t.id)"
      >
        <i
          class="bi"
          :class="
            t.type === 'success'
              ? 'bi-check-circle-fill'
              : t.type === 'danger'
              ? 'bi-x-circle-fill'
              : 'bi-info-circle-fill'
          "
        ></i>
        <span>{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { useToast } from "../composables/useToast";
const { toasts, remove } = useToast();
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.app-toast {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 260px;
  max-width: 360px;
  padding: 14px 18px;
  border-radius: 12px;
  color: #fff;
  font-weight: 500;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.app-toast i {
  font-size: 20px;
}
.app-toast--success {
  background: #16a34a;
}
.app-toast--danger {
  background: #dc2626;
}
.app-toast--info {
  background: #2563eb;
}
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(40px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
</style>
